import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetGeneralStatisticsProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetGeneralStatistics: FC<SrWidgetGeneralStatisticsProps> = ({ matchId, ...props }) => {
    const widgetProps = {
        matchId: matchId,
        disableWidgetHeader: true,
        disableMatchHeader: true,
        chartType: 'bullet'
    };
    return <SrWidget widgetName="match.generalStatistics" widgetProps={widgetProps} {...props} />;
};
